import React, { useRef, useState, useEffect } from "react";
import Header from "./components/header";
import Message from "./components/message";
import icon from "./static/btnRight.png";
import { useSelector } from "react-redux";
import { RootState } from "./store";

const App: React.FC = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const floatBtnRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(true);
  const [buttonWidth, setButtonWidth] = useState(0);

  // 从Redux获取链接
  const apkUrl = useSelector((state: RootState) => state.apkUrl);
  const exeUrl = useSelector((state: RootState) => state.exeUrl);
  const ipaUrl = useSelector((state: RootState) => state.ipaUrl);

  // 检测设备类型
  function isMobile() {
    const mobileReg =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const userAgent = navigator.userAgent;

    if (mobileReg.test(userAgent)) {
      if (/Android/i.test(userAgent)) {
        return "Android";
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iOS";
      }
    }

    return "window";
  }
  // 滚动监听逻辑
  useEffect(() => {
    if (!divRef.current) return;
    const container = divRef.current;

    // 获取按钮宽度
    if (floatBtnRef.current) {
      setButtonWidth(floatBtnRef.current.offsetWidth);
    }

    const handleScroll = () => {
      if (!floatBtnRef.current) return;

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // 控制按钮定位
      if (scrollTop + clientHeight >= scrollHeight - 60) {
        setIsFixed(false);
      } else {
        setIsFixed(true);
      }
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);
  function checkAppInstalled() {
    // 1. 定义应用的Scheme协议（需与Android客户端注册的一致，如"myapp://"）
    const appScheme = "myapp://open_deep_surf";
    // 或使用应用包名（需客户端支持，部分浏览器可能有限制）
    // const appPackage = "com.mycompany.myapp";
    // const appScheme = `intent://#Intent;package=${appPackage};scheme=myapp;end`;

    // 2. 尝试唤醒应用
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appScheme; // 触发应用唤醒
    document.body.appendChild(iframe);

    // 3. 超时检测（若3秒内未唤醒，则视为未安装）
    const checkTimeout = 3000; // 超时时间（毫秒）
    let isInstalled = false;

    // 监听页面是否被隐藏（若唤醒成功，页面会被切换到后台，visibilityState变为hidden）
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        isInstalled = true; // 应用已安装，触发了跳转
      }
    });

    // 超时后判断结果
    setTimeout(() => {
      document.body.removeChild(iframe); // 清理iframe
      if (isInstalled) {
        // console.log("应用已安装，已唤醒");
      } else {
        window.location.href = apkUrl;
        // 这里可以添加下载逻辑，如跳转到应用商店
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.mycompany.myapp';
      }
    }, checkTimeout);
  }

  return (
    <div
      className="w-[100vw] h-[100vh] flex flex-col overflow-y-auto"
      style={{}}
      ref={divRef}
    >
      <Header />
      <Message />

      {/* 悬浮按钮容器 */}
      <div className="h-[88px] flex items-center relative mt-[20px] text-[14px]">
        {/* 占位元素 */}
        {isFixed && (
          <div
            className="invisible w-[100px] h-[50px] mx-auto"
            style={{ width: `${buttonWidth}px` }}
          ></div>
        )}

        {/* 悬浮按钮 */}
        <div
          ref={floatBtnRef}
          className={`w-[202px] bg-[#4F6BFEFF] h-[44px] flex items-center justify-center rounded-3xl text-white font-bold cursor-pointer gap-[4px] ${
            isFixed
              ? "fixed bottom-5 left-1/2 transform -translate-x-1/2"
              : "mx-auto static"
          } hover:bg-[#4c67ee]`}
          style={isFixed ? { left: "50%", transform: "translateX(-50%)" } : {}}
          onClick={() => {
            if (isMobile() === "window") {
              window.open(exeUrl);
            } else if (isMobile() === "Android") {
              checkAppInstalled();
            } else {
              window.open(ipaUrl);
            }
          }}
        >
          <img src={icon} alt="按钮图标" />
          开始使用DeepSurf
          <img src={icon} alt="按钮图标" className="rotate-180" />
        </div>
      </div>

      {/* 底部提示文本 */}
      <div className="mb-3 text-center text-[rgba(0,0,0,.3)] flex justify-center mt-3">
        <span>畅享AI带来的超能力</span>
      </div>
    </div>
  );
};

export default App;
